import { Controller } from "@hotwired/stimulus"

// Analytics controller for tracking user interactions
// Connects to data-controller="analytics"
export default class extends Controller {
  static values = {
    section: String,
    action: String,
    event: String,
    location: String
  }

  connect() {
    this.hoveredBenefitCards = new WeakSet()
    this.boundClick = this.handleClick.bind(this)
    this.boundPointerEnter = this.handlePointerEnter.bind(this)

    this.element.addEventListener("click", this.boundClick)
    this.element.addEventListener("pointerenter", this.boundPointerEnter, true)
  }

  disconnect() {
    this.element.removeEventListener("click", this.boundClick)
    this.element.removeEventListener("pointerenter", this.boundPointerEnter, true)
  }

  handleClick(event) {
    const element = event.target.closest('[data-analytics-action], [data-action="click"], [data-event], [data-section], a, button')
    if (!element || !this.element.contains(element)) return

    const wantsTracking = element.dataset.analyticsAction || element.dataset.action === "click" || element.dataset.event || element.dataset.section
    if (!wantsTracking) return

    const eventData = {
      section: element.dataset.section || this.sectionValue,
      action: element.dataset.analyticsAction || element.dataset.action || this.actionValue || "click",
      event: element.dataset.event || this.eventValue || "element_click",
      location: element.dataset.location || this.locationValue,
      href: element.href || null,
      text: element.textContent.trim(),
      timestamp: new Date().toISOString()
    }

    this.sendAnalyticsEvent(eventData)
  }

  handlePointerEnter(event) {
    const card = event.target.closest("[data-benefit]")
    if (!card || !this.element.contains(card) || this.hoveredBenefitCards.has(card)) return

    this.hoveredBenefitCards.add(card)

    const eventData = {
      section: card.dataset.section || this.sectionValue || "post-job-cta",
      action: "hover",
      event: card.dataset.event || "benefit_card_hover",
      benefit: card.dataset.benefit,
      benefitTitle: card.dataset.benefitTitle,
      location: card.dataset.location || this.locationValue || "homepage-section",
      timestamp: new Date().toISOString()
    }

    this.sendAnalyticsEvent(eventData)
  }

  sendAnalyticsEvent(eventData) {
    if (typeof gtag !== 'undefined') {
      gtag('event', eventData.event, {
        event_category: eventData.section,
        event_label: eventData.text || eventData.benefit,
        event_action: eventData.action,
        page_location: eventData.location
      })
    }

    if (typeof ga !== 'undefined') {
      ga('send', 'event', {
        eventCategory: eventData.section,
        eventAction: eventData.action,
        eventLabel: eventData.text || eventData.benefit,
        eventValue: 1
      })
    }

    if (this.hasCustomEndpoint()) {
      this.sendToCustomEndpoint(eventData)
    }

    if (typeof mixpanel !== 'undefined') {
      mixpanel.track(eventData.event, eventData)
    }

    if (typeof analytics !== 'undefined' && analytics.track) {
      analytics.track(eventData.event, eventData)
    }
  }

  hasCustomEndpoint() {
    return document.querySelector('meta[name="analytics-endpoint"]') !== null
  }

  sendToCustomEndpoint(eventData) {
    const endpoint = document.querySelector('meta[name="analytics-endpoint"]')?.content
    
    if (endpoint) {
      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: JSON.stringify(eventData)
      }).catch((error) => {
        console.error("Analytics tracking error:", error)
      })
    }
  }
}
